import type { PfStoreState } from '../store'

/**
 * The saved draft to delete when the client leaves the flow with an empty cart, or undefined. Such a draft is never
 * listed, so keeping it only piles up one hidden draft per property pick. A draft still loading is left alone: its
 * cart has not arrived yet, so it only looks empty.
 */
export const emptyDraftToDiscard = (state: Pick<PfStoreState, 'items' | 'draft'>): string | undefined => {
  const { draftId, isHydrating, isClosed } = state.draft
  if (!draftId || isHydrating || isClosed || state.items.length > 0) return undefined
  return draftId
}
